import React from 'react';
import { TDoneVoteGroup, TVotesGroup } from '../../../../store/interactive/types';
import { Success } from '../../../../test/screens/Sucess';
import { useGroup } from './hooks/useGroup';
import { CheckDoneVoteGroup, SendVoteGroup } from '../../../../store/interactive/actions';
import { Polls } from './Polls';

interface VoteGroupProps {
  votesGroup: TVotesGroup;
  disabled: boolean;
  doneVotes: TDoneVoteGroup | null;
}

export const VotesGroup: React.FC<VoteGroupProps> = ({ votesGroup, disabled, doneVotes }) => {
  const { vote, end, sendValue } = useGroup({
    votesGroup,
    SendVote: SendVoteGroup,
    CheckVoteDoneGroup: CheckDoneVoteGroup,
    done: doneVotes,
  });

  if (!vote) {
    return null;
  }

  if (votesGroup.status === 3 || votesGroup.status === 1) {
    return (
      <div style={{ color: 'green', margin: '20px', textAlign: 'center' }}>
        <span>{votesGroup.status === 1 ? 'Голосування не розпочато' : 'Голосування завершено'}</span>
      </div>
    );
  }

  if (end) {
    return (
      <div style={{ marginTop: '40px' }}>
        <Success>
          <h2>Дякуємо! За Ваш голос</h2>
        </Success>
      </div>
    );
  }

  return <Polls type="pass" vote={vote} disabled={disabled} sendValue={sendValue} />;
};
